// extracted by mini-css-extract-plugin
var _1 = "TaskAdd_field__oMMbp";
export { _1 as "field" }
